import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import EditUserModal from './EditUserModal';
import CreateUserModal from './CreateUserModal';
import ReactPaginate from 'react-paginate'; // Import ReactPaginate
import { UserContext } from '../../../contexts/UserContext';

const Users = () => {
    const [users, setUsers] = useState([]);
    const [rolesMap, setRolesMap] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const { user } = useContext(UserContext);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const usersPerPage = 10; // Adjust the number of users per page

    // Filter states
    const [nameFilter, setNameFilter] = useState('');
    const [roleFilter, setRoleFilter] = useState('');

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const usersCollection = collection(db, 'user');
                const usersSnapshot = await getDocs(usersCollection);
                let usersList = usersSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // Apply name filter
                if (nameFilter) {
                    usersList = usersList.filter(user =>
                        user.nom.toLowerCase().includes(nameFilter.toLowerCase())
                    );
                }

                // Apply role filter
                if (roleFilter) {
                    usersList = usersList.filter(user =>
                        user.role === roleFilter
                    );
                }

                setUsers(usersList);
            } catch (error) {
                console.error("Error fetching users: ", error);
            }
        };

        const fetchRoles = async () => {
            try {
                const rolesCollection = collection(db, 'roles');
                const rolesSnapshot = await getDocs(rolesCollection);
                const rolesList = rolesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                const rolesMap = rolesList.reduce((map, role) => {
                    map[role.id] = role.nom;
                    return map;
                }, {});
                setRolesMap(rolesMap);
            } catch (error) {
                console.error("Error fetching roles: ", error);
            }
        };

        fetchUsers();
        fetchRoles();
    }, [nameFilter, roleFilter]);

    // Calculate pagination data
    const indexOfLastUser = (currentPage + 1) * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
    const pageCount = Math.ceil(users.length / usersPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (user) => {
        setSelectedUser(user);
        setShowEditModal(true);
    };

    const handleSaveEdit = (updatedUser) => {
        setUsers(prevUsers => 
            prevUsers.map(u => 
                u.id === updatedUser.id ? updatedUser : u
            )
        );
    };

    const handleShowCreate = () => {
        setShowCreateModal(true);
    };

    const handleSaveCreate = (newUser) => {
        setUsers(prevUsers => [...prevUsers, newUser]);
    };

    const handleDelete = async (userId) => {
        const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?");
        if (confirmDelete) {
            try {
                await deleteDoc(doc(db, 'user', userId));
                setUsers(prevUsers => prevUsers.filter(user => user.id !== userId));
            } catch (error) {
                console.error("Error deleting user: ", error);
            }
        }
    };
    

    const getRoleName = (roleId) => {
        return rolesMap[roleId] || 'Unknown';
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    <br/>
                    {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                    <button className="btn btn-org mb-4" onClick={handleShowCreate}>
                        <FontAwesomeIcon icon={faPlus} /> Ajouter un utilisateur
                    </button>
                    )}
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                     
                            <div className="mb-3 d-flex align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Liste des utilisateurs</h6>
                            <div className="mb-0 flex-grow-1 mr-1 col-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Filtrer par nom"
                                    value={nameFilter}
                                    onChange={(e) => setNameFilter(e.target.value)}
                                />
                            </div>
                            <div className="mb-0 flex-grow-1 mr-1 col-4">
                                <select
                                    className="form-control "
                                    value={roleFilter}
                                    onChange={(e) => setRoleFilter(e.target.value)}
                                >
                                    <option value="">Tous les rôles</option>
                                    {Object.entries(rolesMap).map(([id, nom]) => (
                                        <option key={id} value={id}>{nom}</option>
                                    ))}
                                </select>
                            </div>
                            </div>
                        </div>
                        <div className="card-body">
                     
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nom</th>
                                            <th>Rôle</th>
                                            <th>Email</th>
                                            <th>Téléphone</th>
                                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                            <th>Actions</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentUsers.map((user1) => (
                                            <tr key={user1.id}>
                                                <td>{user1.id}</td>
                                                <td>{user1.nom}</td>
                                                <td>{getRoleName(user1.role)}</td>
                                                <td>{user1.email}</td>
                                                <td>{user1.tele}</td>
                                                {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                <td>
                                                    <button className="btn btn-primary btn-circle btn-sm mr-2" onClick={() => handleShowEdit(user1)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button className="btn btn-danger btn-circle btn-sm" onClick={() => handleDelete(user1.id)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-start'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            {selectedUser && (
                <EditUserModal
                    show={showEditModal}
                    handleClose={() => setShowEditModal(false)}
                    user={selectedUser}
                    handleSave={handleSaveEdit}
                    rolesMap={rolesMap}
                />
            )}
            <CreateUserModal
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                handleSave={handleSaveCreate}
                rolesMap={rolesMap}
            />
        </div>
    );
};

export default Users;
